import AppRouter from 'common/AppRouter';
import useTabsBuilder from 'components/RouterTabs/useTabsBuilder';
import { useSelector } from 'react-redux';
import { isTeamLicenseSelector } from 'state/selectors/license';
import ProjectProgressionCta from './ProjectProgression/ProjectProgressionCTA';
import ProjectProgression from './ProjectProgression';
import ProjectProgressionInsightsConfig from 'views/root/views/home/views/projects/Forecasting/ProjectProgression/Insights/settings/InsightsConfig';
import Forecast from './Forecast';
import useProjectProgressionPermissions from './ProjectProgression/useProjectProgressionPermissions';
import useForecastPermissions from './Forecast/useForecastPermissions';

const useForecastingTabs = () => {
  const isTeamLicense = useSelector(isTeamLicenseSelector);
  const tabsBuilder = useTabsBuilder();

  const projectProgressionPermissions = useProjectProgressionPermissions();
  const forecastPermissions = useForecastPermissions();

  tabsBuilder.initTabs(
    [
      {
        name: 'Progress Over Time',
        path: AppRouter.PROJECTS_PROJECT_PROGRESSION.path,
        permissions: projectProgressionPermissions,
        component: isTeamLicense ? (
          <ProjectProgressionCta />
        ) : (
          <ProjectProgression />
        ),
        subRoutes: [
          {
            path: AppRouter.PROJECTS_PROJECT_PROGRESSION_INSIGHTS_CONFIG.path,
            component: <ProjectProgressionInsightsConfig />
          }
        ]
      },
      {
        name: 'Forecast',
        path: AppRouter.PROJECTS_FORECASTING_FORECAST.path,
        permissions: forecastPermissions,
        component: <Forecast />
      }
    ].filter(Boolean)
  );
  return tabsBuilder.build();
};

export default useForecastingTabs;
